import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import "./LoginPage.css";
import PostApiCall from "../../../helpers/PostApi";
import Notiflix from "notiflix";
import { FaEye, FaEyeSlash } from "react-icons/fa";
export default function LoginPage() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [passVisible, setPassVisible] = useState(false);
  const togglePassVisible = () => {
    setPassVisible(!passVisible);
  };
  const handleLogin = (e) => {
    e.preventDefault();
    if (
      userName != "" &&
      password != "" &&
      userName != null &&
      password != null
    ) {
      Notiflix.Loading.dots();
      PostApiCall.postRequest(
        {
          email: userName,
          password: password,
          action: "login",
          actiondate: new Date(),
        },
        "AuthenticateUser"
      ).then((result) =>
        result.json().then((obj) => {
          if (result.status === 200 || result.status === 201) {
            localStorage.setItem("LoginDetail", JSON.stringify(obj.data[0]));
            sessionStorage.setItem("access", obj.token);
            window.location.href = "/admin/addcertificate";
          } else {
            Notiflix.Loading.remove();
            Notiflix.Notify.failure("Authentication Failed!");
          }
        })
      );
    } else {
      Notiflix.Notify.failure("Please Enter Username and Password!");
    }
  };
  // const handleLogin = (e) => {
  //   e.preventDefault();
  //   console.log(e);

  //   localStorage.setItem("isAdmin", JSON.stringify(true));
  //   window.location.href = "/admin/addcertificate";
  // };

  return (
    <>
      <section className="login-section">
        <Container fluid>
          <div className="row">
            <div className="col-12">
              <div className="login-form text-white">
                <div className="section-bootom-border pb-3">
                  <h1 className="text-start text-white">Login</h1>
                  <p className="mb-0">
                    Access your account to explore certified diamonds,
                  </p>
                </div>
                <Form className="py-3" onSubmit={handleLogin}>
                  <Form.Group className="mb-3 form-inputs ">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={userName}
                      onChange={(e) => {
                        setUserName(e.target.value);
                      }}
                      placeholder="Enter your email"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3 form-inputs">
                    <Form.Label>Password</Form.Label>
                    <div className="position-relative pass-input">
                      <Form.Control
                        type={passVisible ? "text" : "password"}
                        name="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        required
                      />
                      <span>
                        {passVisible ? (
                          <FaEye onClick={togglePassVisible} />
                        ) : (
                          <FaEyeSlash onClick={togglePassVisible} />
                        )}
                      </span>
                    </div>
                  </Form.Group>
                  <div className="text-end">
                    <Button type="submit" variant="light">
                      Login
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
